import { Row, Column, Caption } from 'gatsby-theme-carbon/src/components/Grid';
import { Video } from 'gatsby-theme-carbon/src/components/Video';
import img1 from "../../../../src/visuals/design/ux_3_2_eg.png";
import { withPrefix } from "gatsby";
import ToolkitRequirement from "../../../../src/components/rms_resources/requirements";
import ToolkitReference from "../../../../src/components/rms_resources/references";
import ToolkitTechnique from "../../../../src/components/rms_resources/techniques";
import ToolkitTopic from "../../../../src/components/rms_resources/topics";
import * as React from 'react';
export default {
  Row,
  Column,
  Caption,
  Video,
  img1,
  withPrefix,
  ToolkitRequirement,
  ToolkitReference,
  ToolkitTechnique,
  ToolkitTopic,
  React
};